enum EnumRecipientRole {
  Signer = 'signer',
  Approver = 'approver',
  CC = 'cc',
}

export default EnumRecipientRole;
